import { Fragment } from 'react'
import { useMonitoringImmediate } from '../hooks/useMonitoringImmediate'
import { useMonitoringScheduled } from '../hooks/useMonitoringScheduled'
import { useGetRealtimeAppointments } from '../queries/useGetRealtimeAppointments'
import { useLocation } from 'react-router-dom'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'

const FIVE_SECONDS_IN_MS = 5000
const TWENTY_SECONDS_IN_MS = 20000

export const RealtimeAttendanceMonitoring = () => {
  const location = useLocation()
  const { user } = useAuthContext()

  const isOnVideoCallPage = location.pathname.includes('chamada')

  const { data: realtimeAppointments } = useGetRealtimeAppointments(
    user?.patientId,
    isOnVideoCallPage ? FIVE_SECONDS_IN_MS : TWENTY_SECONDS_IN_MS,
  )

  useMonitoringImmediate({
    realtimeAppointments,
  })
  useMonitoringScheduled({
    realtimeAppointments,
  })

  return <Fragment />
}
